exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-5a7905ec] .v-overlay__scrim {\n  pointer-events: auto;\n  background: rgb(var(--v-theme-on-surface));\n  border-radius: inherit;\n  bottom: 0;\n  left: 0;\n  opacity: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n}\n", ""]);

// exports
